import 'swiper/css';
import './submenu.scss';
import React, { useState, memo, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';
import SubmenuItem from './SubmenuItem';
import { useTheme } from '..';
const Submenu = _ref => {
  let {
    menuItems = [],
    focusItemIndex,
    onChange,
    className,
    customBtnWrap
  } = _ref;
  const {
    theme
  } = useTheme();
  const [activeItemIndex, setActiveItemIndex] = useState(focusItemIndex);
  const [left, setLeft] = useState();
  const [width, setWidth] = useState();
  useEffect(() => {
    if (focusItemIndex !== activeItemIndex) setActiveItemIndex(focusItemIndex);
  }, [focusItemIndex]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('wrts-submenu hide-on-print', className, theme)
  }, /*#__PURE__*/React.createElement(Swiper, {
    slidesPerView: "auto",
    freeMode: true,
    spaceBetween: 0,
    modules: [FreeMode],
    observeSlideChildren: true,
    className: "wrts-submenu-items"
  }, menuItems.map(_ref2 => {
    let {
      title,
      index,
      notificationCount,
      notificationPriorityType,
      notificationRegularType,
      link
    } = _ref2;
    const updateActiveItemIndex = (leftPosition, itemWidth, changeIndex) => {
      setLeft(leftPosition);
      setWidth(itemWidth);
      if (changeIndex) {
        onChange(index, link);
        setActiveItemIndex(index);
      }
    };
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      key: index
    }, /*#__PURE__*/React.createElement(SubmenuItem, {
      activeItem: activeItemIndex === index,
      title: title,
      notificationCount: notificationCount,
      notificationRegularType: notificationRegularType,
      notificationPriorityType: notificationPriorityType,
      updateActiveItemIndex: updateActiveItemIndex,
      width: width,
      left: left,
      dataName: title,
      link: link,
      customBtnWrap: customBtnWrap
    }));
  }), /*#__PURE__*/React.createElement("span", {
    slot: "wrapper-end",
    className: "wrts-submenu-underline",
    style: {
      left: `${left}px`,
      width: `${width}px`
    }
  })));
};
Submenu.defaultProps = {
  focusItemIndex: 0,
  onChange: () => {}
};
Submenu.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  focusItemIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func,
  customBtnWrap: PropTypes.func
};
export default /*#__PURE__*/memo(Submenu);